import { combineEpics, type Epic } from 'redux-observable';
import { filter, map } from 'rxjs';
import { request } from '@/core';
import { listProperties } from '@/api/istaff/property';
import { searchProperties, setError, setLoading, setResults } from '../actions';

const searchLoadingEpic: Epic = (action$) =>
  action$.pipe(
    filter(searchProperties.match),
    map(() => setLoading(true)),
  );

const searchPropertiesEpic: Epic = (action$) =>
  action$.pipe(
    filter(searchProperties.match),
    map(({ payload }) => payload),
    request(listProperties, searchProperties),
  );

const searchSucceededEpic: Epic = (action$) =>
  action$.pipe(
    filter(searchProperties.succeeded.match),
    map(({ payload }) => setResults(payload)),
  );

const searchFailedEpic: Epic = (action$) =>
  action$.pipe(
    filter(searchProperties.failed.match),
    map(({ payload }) => setError(payload)),
  );

export default combineEpics(
  searchLoadingEpic,
  searchPropertiesEpic,
  searchSucceededEpic,
  searchFailedEpic,
);
